import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'SharedBack',
  setup(__props) {

const router = useRouter();

function handleBack() {
  router.push({
    name: "Launcher",
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", null, [
    _createElementVNode("i", {
      class: "fas fa-arrow-left tw-text-gray-500",
      style: {"font-size":"24px"},
      onClick: handleBack
    })
  ]))
}
}

})